/* unplugin-vue-components disabled */import { render } from "./ReleaseNoteHistory.vue?vue&type=template&id=99f68a12&scoped=true"
import script from "./ReleaseNoteHistory.vue?vue&type=script&lang=js"
export * from "./ReleaseNoteHistory.vue?vue&type=script&lang=js"

import "./ReleaseNoteHistory.vue?vue&type=style&index=0&id=99f68a12&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-99f68a12"]])

export default __exports__